import { __decorate } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { workspaceApiUrlPrefix } from '@workspace/shared/constants/envConfig';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
let ChemStructureApi = class ChemStructureApi extends PsHttpService {
    get options() {
        return {
            baseURL: workspaceApiUrlPrefix,
            headers: {
                'X-API-Version': '2.0',
            },
        };
    }
    /**
     * 获取+n的化合物数据
     * @param params
     * @returns
     */
    async getMoreStructure(params) {
        const { spaceId, folderId, patentId, page, rows } = params;
        const res = await this.post({
            url: `space/${spaceId}/folder/${folderId}/patent/${patentId}/structures`,
            data: {
                page,
                rows,
            },
        });
        return res.data;
    }
    /**
     * 获取单篇专利命中的化合物query id，用以跳转到chemical search结果页
     * @param params
     * @returns
     */
    async getHitStructureQueryId(params) {
        const { spaceId, folderId, patentId } = params;
        const res = await this.post({
            url: `space/${spaceId}/folder/${folderId}/patent/${patentId}/structure-extract`,
        });
        return res.data;
    }
};
ChemStructureApi = __decorate([
    injectable()
], ChemStructureApi);
export { ChemStructureApi };
